<template>
  <v-card class="mx-auto elevation-10" style="border-radius: 10px" max-width="434" tile>
    <v-img height="100%" src="https://wallpaperbro.com/img/976598.jpg">
      <v-row align="end" class="fill-height">
        <v-col align-self="start" cols="12">
          <v-row justify="space-between">
            <div class="pl-3 ml-5">
              <v-avatar class="profile elevation-20" color="grey" size="100">
                <v-img :src="profileUrl"></v-img>
              </v-avatar>
            </div>
            <!-- <div class="pl-3 mr-5" style="margin-top: -20px">
              <v-switch dark color="teal" v-model="isActive" label="Active"></v-switch>
            </div>-->
          </v-row>
        </v-col>

        <v-row align="end">
          <v-col class="py-0" cols="8">
            <v-list-item color="rgba(0, 0, 0, .4)" dark>
              <v-list-item-content>
                <v-list-item-title class="title my-0 py-0">
                  {{ user.firstName }} {{ user.lastName }}
                  <span
                    class="caption orange--text"
                  >({{ user.role}})</span>
                </v-list-item-title>
                <v-list-item-subtitle class="caption blue--text my-0 py-0">@{{user.username}}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ user.proffession}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="3">
            <v-row align="end" justify="end">
              <v-dialog v-model="dialog" persistent max-width="35%">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    style="font-size: 3px"
                    color="teal lighten-2"
                    class="elevation-19 mb-0 pb-0"
                    @click="getUserDetail"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <v-card style="border-radius: 10px" class="pa-0 ma-0">
                  <v-col>
                    <v-row justify="space-between" align="center" class="my-0 py-0">
                      <span class="ml-5 title font-weight-bold">User Detial</span>

                      <v-btn icon class="mr-3" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-row>
                    <v-row class="ml-0 pl-0" align="center">
                      <v-avatar class="profile elevation-20 ml-5" color="grey" size="80">
                        <v-img src="https://cdn.vuetifyjs.com/images/profiles/marcus.jpg"></v-img>
                      </v-avatar>
                      <v-col>
                        <v-card-title
                          class="headline mb-0 pb-0"
                        >{{ userDetail.firstName + " " + userDetail.lastName }}</v-card-title>
                        <v-card-text class="mb-0 pb-0">{{ userDetail.proffession }}</v-card-text>
                        <v-card-text class="mt-0 pt-0">
                          (
                          <span class="blue--text">{{ userDetail.role }}</span>
                          )
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
              </v-dialog>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    user: {
      type: Object
      // required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapState("auth", ["userDetail"]),
    profileUrl() {
      if (this.user.sex == "Male") {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/m.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/m.png");
        } else return require("@/assets/images/ST/m.png");
      } else {
        if (this.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/f.jpg");
        } else if (this.user.proffession == "Developer") {
          return require("@/assets/images/DV/f.png");
        } else return require("@/assets/images/ST/f.png");
      }
    }
  },
  methods: {
    ...mapActions("auth", ["showUser"]),
    getUserDetail() {
      this.showUser(this.user._id);
      setTimeout(() => {
        this.dialog = true;
      }, 300);
    }
  }
};
</script>